/* Coaster Rizz - the "pairs well with" offer, and the popup that carries it.

   Natalie, 2026-09-26, asked for both: a box that sits under the buy button
   for whoever scrolls, and a popup for whoever adds to cart.

   WHERE THE POPUP MAY AND MAY NOT APPEAR. Not at the checkout - Shopify sells
   that surface only on Plus - and not after payment, which needs a PayPal
   approval this shop cannot get (D-300). The storefront is ours, so the popup
   lives here, and it fires at the one moment the research actually supports:
   AFTER the customer has committed to the mug, never before. It is shown once
   per visit, closes on Escape, on the backdrop, or on either button, and it
   never blocks anything.

   The trigger is a wrapper around fetch, because every add-to-cart in Craft -
   the product form, quick add, the drawer - goes through /cart/add. Watching
   the network rather than any one button means nothing is missed and no theme
   file has to be edited to hook it up. */
(function () {
  var box = document.getElementById('cr-offer');
  var pop = document.getElementById('cr-pop');
  if (!box && !pop) return;

  var shown = false;
  var KEY = 'cr-pop-seen-' + (window.location.pathname || '');

  function bump() {
    var b = document.querySelector('.cart-count-bubble span');
    if (!b) return;
    var n = parseInt((b.textContent || '').replace(/\D/g, ''), 10);
    if (!isNaN(n)) b.textContent = n + 1;
  }

  function add(btn) {
    var vid = btn.getAttribute('data-vid');
    if (!vid || btn.disabled) return;
    var was = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.textContent = 'Added to your cart';
      bump();
      if (pop && !pop.hidden) setTimeout(hide, 1200);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = was;
    });
  }

  function show() {
    if (!pop || shown) return;
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    shown = true;
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    pop.hidden = false;
    document.addEventListener('keydown', esc);
    var first = pop.querySelector('[data-cr-add]');
    if (first) first.focus();
  }

  function hide() {
    if (!pop) return;
    pop.hidden = true;
    document.removeEventListener('keydown', esc);
  }

  function esc(e) { if (e.key === 'Escape' || e.keyCode === 27) hide(); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('[data-cr-add]');
    if (a) { e.preventDefault(); add(a); return; }
    var c = t.closest('[data-cr-close]');
    if (c) { e.preventDefault(); hide(); }
  });

  if (pop) {
    pop.addEventListener('click', function (e) { if (e.target === pop) hide(); });

    var original = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var out = original.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1 && !shown) {
        try {
          out.then(function (r) { if (r && r.ok) setTimeout(show, 700); })
             .catch(function () {});
        } catch (e) {}
      }
      return out;
    };
  }
})();